import { render } from "./AboutViewHeader.vue?vue&type=template&id=5e4bc561"
import script from "./AboutViewHeader.vue?vue&type=script&lang=js"
export * from "./AboutViewHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__